export default __webpack_public_path__ + "static/media/QuATRo_Siegel_2022_Gold.f370dc13.svg";